import '../assets/styles/Contact.scss';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Lottie from "lottie-react";
import CvAnimation from "../assets/Lottie/Cv.json";
function Contact() {
  return (
    <div id="contact">
      <div className="items-container">  
          <div className="section-title">
                  <span className="line"></span>
                  <h2>
                    CONNECT <span>/ GET IN TOUCH</span>
                  </h2>
                </div>
              <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
        
      </div>  

      <div className="contact-cards">
      
      <a className="contact-card" href="https://mail.google.com/mail/?view=cm&fs=1&to=youremail@gmail.com" target="_blank" rel="noreferrer">
        <div className="card-left">
          <div className="icon email"><EmailIcon/></div>
          <div>
            <h4>Email</h4>
            <p>jamalyuosef000@gmail.com</p>
            <span>Send message</span>
          </div>
        </div>
        <ArrowForwardIosIcon className="arrow"/>
      </a>

      <a className="contact-card" href="https://www.linkedin.com/in/yuosefjamal33/" target="_blank" rel="noreferrer">
        <div className="card-left">
          <div className="icon linkedin"><LinkedInIcon/></div>
          <div>
            <h4>LinkedIn</h4>
            <p>yousif jamal</p>
            <span>Connect</span>
          </div>
        </div>
        <ArrowForwardIosIcon className="arrow"/>
      </a>

      <a className="contact-card" href="https://github.com/yuosef33" target="_blank" rel="noreferrer">
        <div className="card-left">
          <div className="icon github"><GitHubIcon/></div>
          <div>
            <h4>GitHub</h4>
            <p>@yuosef33</p>
            <span>View code</span>
          </div>
        </div>
        <ArrowForwardIosIcon className="arrow"/>
      </a>

      <a className="contact-card" href="https://wa.me/201032840774" target="_blank" rel="noreferrer">
        <div className="card-left">
          <div className="icon whatsapp"><WhatsappIcon/></div>
          <div>
            <h4>Whatsapp</h4>
            <p>@yuosef</p>
            <span>send message</span>
          </div>
        </div>
        <ArrowForwardIosIcon className="arrow"/>
      </a>

    </div>

      
          <div className="my-resume-section">
             <Lottie 
      animationData={CvAnimation}
      loop={true}
      style={{ width: 200, height: 200 }}
    />
            <div className="quick-message">
        <div className="iconn">
          <AccountBoxIcon />
        </div>
        <h4>My Resume</h4>
        <a  href="/Yuosef-jamal-Resume.pdf" download className="email-btn">
          <DownloadIcon />
          Download CV
        </a>
      </div>

      
          </div>
    </div>
  );
}

export default Contact;